module.exports = __webpack_public_path__ + "static/media/upgrade2.1eb499ca.png";